
export default {
  name: 'IconSearch',
};
